// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");

function ColorPicker(props) {
  var __showHex = props.showHex;
  var __ariaLabel = props.ariaLabel;
  var onChange = props.onChange;
  var value = props.value;
  var ariaLabel = __ariaLabel !== undefined ? __ariaLabel : "Pick color";
  var showHex = __showHex !== undefined ? __showHex : true;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("label", {
                      children: [
                        JsxRuntime.jsx("span", {
                              className: "block w-10 h-10 rounded-md border border-gray-300 shadow-sm",
                              style: {
                                backgroundColor: value
                              }
                            }),
                        JsxRuntime.jsx("input", {
                              className: "absolute inset-0 w-full h-full opacity-0 cursor-pointer border-0 p-0 m-0",
                              type: "color",
                              value: value,
                              onChange: (function ($$event) {
                                  Curry._1(onChange, $$event.target.value);
                                })
                            })
                      ],
                      "aria-label": ariaLabel,
                      className: "relative inline-flex items-center justify-center cursor-pointer select-none flex-shrink-0",
                      title: ariaLabel
                    }),
                showHex ? JsxRuntime.jsx("span", {
                        children: value,
                        className: "text-sm text-gray-600 font-mono uppercase"
                      }) : null
              ],
              className: "flex items-center gap-3"
            });
}

var make = ColorPicker;

exports.make = make;
/* react/jsx-runtime Not a pure module */
